//
import BranchOfficeModel from '@/models/General/GBranchOffice'
import RoleModel from '@/models/Role'

//
import { required } from '@/services/validations'
import GBranchOfficeHeaders from '@/views/General/GBranchOffice/GBranchOfficeHeaders'
import headers from './headers'

//
export default props => [
    {
        name: 'rut',
        type: 'rut-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Rut',
            rules: [required],
        },
    },
    {
        name: 'names',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Nombre',
            rules: [required],
        },
    },
    {
        name: 'last_name1',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Primer Apellido',
            rules: [required],
        },
    },
    {
        name: 'last_name2',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Segundo Apellido',
        },
    },
    {
        name: 'email',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Correo',
            rules: [required],
        },
    },
    {
        name: 'g_branch_office_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            chips: true,
            itemText: 'name',
            itemValue: 'id',
            label: 'Sucursal',
            model: BranchOfficeModel,
            noObject: true,
            paramSearch: 'address',
            rules: [required],
        },
    },
    {
        name: 'auth_code',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Código usuario',
            rules: [required],
        },
    },
    {
        name: 'bar_auth_code',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Código autorización',
        },
    },
    {
        name: 'g_selected_roles',
        type: 'table-field',
        flex: {
            'pt-0': true,
            'xs12': true,
            'd-grid': true,
        },
        props: {
            checkable: true,
            headers,
            noDataText: 'Sin roles.',
            noSearch: false,
            pickerProps: {
                class: 'white',
                filters: [],
                headers,
                parser: row => {
                    row['created_at'] = Date.now()
                    return row
                },
                paramFilter: {
                    user_hasnt_role: props.g_user_id,
                },
                noPagination: false,
                submitText: 'confirmar selección',
                service: RoleModel,
                paramSearch: 'search',
            },
            showPicker: true,
            toolbarTitle: 'Lista de roles asignados al usuario',
        },
        trigger: props.g_selected_roles_trigger,
    },
    {
        name: 'g_selected_branch_offices',
        type: 'table-field',
        flex: {
            'pt-0': true,
            'xs12': true,
            'd-grid': true,
        },
        props: {
            checkable: true,
            headers: GBranchOfficeHeaders,
            noDataText: 'Sin sucursales.',
            pickerProps: {
                filters: [],
                headers: GBranchOfficeHeaders,
                noPagination: false,
                submitText: 'confirmar selección',
                service: BranchOfficeModel,
                paramSearch: 'address',
            },
            showPicker: true,
            toolbarTitle: 'Lista de sucursales disponibles para el usuario',
        },
    },
]
